import { useEffect, useState, type ReactNode } from "react";

import { useIsFetching } from "@tanstack/react-query";

import { AppBoot } from "../ui";

export interface AppBootstrapProps {
  children: ReactNode;
}

/**
 * Keeps the app-level boot mark above the initial route while its data starts
 * and settles. It deliberately runs once per document load: later navigation
 * and refetches retain their local, known-shape loading states.
 */
export function AppBootstrap({ children }: AppBootstrapProps) {
  const isFetching = useIsFetching();
  const [hasMounted, setHasMounted] = useState(false);
  const [isBooting, setIsBooting] = useState(true);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  useEffect(() => {
    if (!hasMounted || isFetching > 0) {
      return;
    }
    setIsBooting(false);
  }, [hasMounted, isFetching]);

  return (
    <>
      {children}
      {isBooting ? <AppBoot /> : null}
    </>
  );
}
